
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/extensions/git-sync",
      function () {
        return require("private-next-pages/extensions/git-sync.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/extensions/git-sync"])
      });
    }
  